import { render } from "./FormulaComparisonChart.vue?vue&type=template&id=038d74f4"
import script from "./FormulaComparisonChart.vue?vue&type=script&lang=js"
export * from "./FormulaComparisonChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__